module.exports = __webpack_public_path__ + "static/img/1压差调节型气动控制机构.3d06ff35.jpg";